import React from 'react';
import asyncComponent from '../../../util/asyncComponent';

import PrivateRoute from './PrivateRoute';
import { Switch } from 'react-router-dom';

const Cadastros = asyncComponent(() => import('../cadastros'));

const PrestacaoModelosImpressao = asyncComponent(() =>
  import('../cadastros/tabelas/PrestacaoModelosImpressao')
);
const CadastroCredor = asyncComponent(() =>
  import('../cadastros/credores/DadosCredores')
);
const Credores = asyncComponent(() =>
  import('../cadastros/credores/ListaCredores')
);
const Digitalizacao = asyncComponent(() =>
  import('../cadastros/credores/DigitalizacaoCredor')
);
const GrupoCredores = asyncComponent(() =>
  import('../cadastros/GrupoCredores/ListaGrupoCredores')
);
const Multiempresas = asyncComponent(() =>
  import('../cadastros/Multiempresas/ListaMultiempresas')
);
const CadastroDevedor = asyncComponent(() =>
  import('../cadastros/devedores/DadosDevedores')
);
const Devedores = asyncComponent(() =>
  import('../cadastros/devedores/ListaDevedores')
);
const CadastroColaborador = asyncComponent(() =>
  import('../cadastros/colaboradores/DadosColaborador')
);
const Colaboradores = asyncComponent(() =>
  import('../cadastros/colaboradores/ListaColaborador')
);
const GrupoColaboradores = asyncComponent(() =>
  import('../cadastros/GrupoColaboradores/ListaGrupoColaboradores')
);
const Fornecedores = asyncComponent(() =>
  import('../cadastros/fornecedores/ListaFornecedores')
);
const CadastroFornecedor = asyncComponent(() =>
  import('../cadastros/fornecedores/DadosFornecedores')
);
const Bancos = asyncComponent(() => import('../cadastros/tabelas/Bancos'));
const QualificacaoTelefones = asyncComponent(() =>
  import('../cadastros/tabelas/QualificacaoTelefones')
);
const QualificacaoChamadas = asyncComponent(() =>
  import('../cadastros/tabelas/QualificacaoChamadas')
);
const QualificacaoChamadasDiscador = asyncComponent(() =>
  import('../cadastros/tabelas/QualificacaoChamadasDiscador')
);
const ClassificacaoAcordos = asyncComponent(() =>
  import('../cadastros/tabelas/ClassificacaoAcordos')
);
const ContasBancarias = asyncComponent(() =>
  import('../cadastros/tabelas/ContasBancarias')
);
const CentroDeCusto = asyncComponent(() =>
  import('../cadastros/tabelas/CentroDeCusto')
);
const PlanoDeConta = asyncComponent(() =>
  import('../cadastros/tabelas/PlanoDeConta')
);
const FormaPagto = asyncComponent(() =>
  import('../cadastros/tabelas/FormaPagto')
);
const MotivoPausa = asyncComponent(() =>
  import('../cadastros/tabelas/MotivoPausa')
);
const SegmentoCredor = asyncComponent(() =>
  import('../cadastros/tabelas/SegmentoCredor')
);
const CategoriasCredor = asyncComponent(() =>
  import('../cadastros/tabelas/CategoriasCredor')
);
const SegmentoDevedor = asyncComponent(() =>
  import('../cadastros/tabelas/SegmentoDevedor')
);
const MarcacoesDeProcessos = asyncComponent(() =>
  import('../cadastros/tabelas/MarcacoesDeProcessos')
);
const FasesColaboradores = asyncComponent(() =>
  import('../cadastros/tabelas/FasesColaboradores')
);
const EspecieTitulo = asyncComponent(() =>
  import('../cadastros/tabelas/EspecieTitulo')
);
const CategoriaInstrucao = asyncComponent(() =>
  import('../cadastros/tabelas/CategoriaInstrucao')
);
const MotivoInadimplencia = asyncComponent(() =>
  import('../cadastros/tabelas/MotivoInadimplencia')
);
const ComissaoPeriodo = asyncComponent(() =>
  import('../cadastros/tabelas/ComissaoPeriodo')
);
/*
const PeriodoComissao = asyncComponent(() =>
  import('../cadastros/tabelas/PeriodoComissao')
);
*/
const Empresa = asyncComponent(() => import('../cadastros/tabelas/Empresa'));
const ParametrosAtraso = asyncComponent(() =>
  import('../cadastros/tabelas/CampanhaProcesso')
);
const ParametrosCarteira = asyncComponent(() =>
  import('../cadastros/tabelas/ParametrosCarteira')
);
const CampanhaDesconto = asyncComponent(() =>
  import('../cadastros/tabelas/CampanhaDesconto')
);
const NegativacaoMotivoRetirada = asyncComponent(() =>
  import('../cadastros/tabelas/NegativacaoMotivoRetirada')
);
const NegativacaoNaturezaInclusao = asyncComponent(() =>
  import('../cadastros/tabelas/NegativacaoNaturezaInclusao')
);

const ModalidadeContrato = asyncComponent(() =>
  import('../cadastros/tabelas/ModalidadeContrato')
);
const ComissaoEscalonada = asyncComponent(() =>
  import('../cadastros/tabelas/ComissaoEscalonada')
);

export default function CadastroRoutes({ match }) {
  return (
    <>
      <Switch>
        <PrivateRoute
          path={`${match.url}/cad/credores/digitalizacao`}
          component={Digitalizacao}
          codigo="cad_credor_v"
        />
        <PrivateRoute
          path={`${match.url}/cad/credores/cadastro/:id`}
          component={CadastroCredor}
          codigo="cad_credor_v_a"
        />
        <PrivateRoute
          path={`${match.url}/cad/credores/cadastro`}
          component={CadastroCredor}
          codigo="cad_credor_c"
        />
        <PrivateRoute
          path={`${match.url}/cad/credores`}
          component={Credores}
          codigo="cad_credor_v"
        />
        <PrivateRoute
          path={`${match.url}/cad/grupo-credores`}
          component={GrupoCredores}
          codigo="cad_credor_grupo"
        />
        <PrivateRoute
          path={`${match.url}/cad/devedores/cadastro/:id`}
          component={CadastroDevedor}
          codigo="cad_devedor_a"
        />
        <PrivateRoute
          path={`${match.url}/cad/devedores/cadastro`}
          component={CadastroDevedor}
          codigo="cad_devedor_c"
        />
        <PrivateRoute
          path={`${match.url}/cad/devedores`}
          component={Devedores}
          codigo="cad_devedor_v"
        />

        <PrivateRoute
          path={`${match.url}/cad/colaboradores/cadastro/:id`}
          component={CadastroColaborador}
          codigo="cad_colaborador_a"
        />
        <PrivateRoute
          path={`${match.url}/cad/colaboradores/cadastro`}
          component={CadastroColaborador}
          codigo="cad_colaborador_c"
        />
        <PrivateRoute
          path={`${match.url}/cad/colaboradores`}
          component={Colaboradores}
          codigo="cad_colaborador_v"
        />
        <PrivateRoute
          path={`${match.url}/cad/equipes`}
          component={GrupoColaboradores}
          codigo="cad_colaborador_grupo"
        />

        <PrivateRoute
          path={`${match.url}/cad/fornecedores/cadastro/:id`}
          component={CadastroFornecedor}
          codigo="cad_fornecedor_a"
        />
        <PrivateRoute
          path={`${match.url}/cad/fornecedores/cadastro`}
          component={CadastroFornecedor}
          codigo="cad_fornecedor_c"
        />
        <PrivateRoute
          path={`${match.url}/cad/fornecedores`}
          component={Fornecedores}
          codigo="cad_fornecedor_v"
        />

        <PrivateRoute
          path={`${match.url}/cad/tabelas/bancos`}
          component={Bancos}
          codigo="tab_bancos"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/qualificacao-telefones`}
          component={QualificacaoTelefones}
          codigo="tabelas_discador"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/qualificacao-chamadas`}
          component={QualificacaoChamadas}
          codigo="tabelas_discador"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/qualificacao-chamadas-discador`}
          component={QualificacaoChamadasDiscador}
          codigo="tabelas_discador"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/classificacao-acordos`}
          component={ClassificacaoAcordos}
          codigo="tab_classifica_acordo"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/contas-bancarias`}
          component={ContasBancarias}
          codigo="tab_contas"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/centro-custo`}
          component={CentroDeCusto}
          codigo="tab_custo"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/plano-conta`}
          component={PlanoDeConta}
          codigo="tab_plano_conta"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/forma-pagto`}
          component={FormaPagto}
          codigo="tab_forma_pagto"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/empresa`}
          component={Empresa}
          codigo="tab_empresas"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/motivo-pausa`}
          component={MotivoPausa}
          codigo="tabelas_discador"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/negativacao-motivos-retirada`}
          component={NegativacaoMotivoRetirada}
          codigo="tab_retirada_negativacao"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/negativacao-natureza-inclusao`}
          component={NegativacaoNaturezaInclusao}
          codigo="tab_inclusao_negativacao"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/segmento-credor`}
          component={SegmentoCredor}
          codigo="tab_segmento_cred"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/categorias-credor`}
          component={CategoriasCredor}
          codigo="tab_categoria_cred"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/segmento-devedor`}
          component={SegmentoDevedor}
          codigo="tab_segmento_dev"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/marcacoes-de-processo`}
          component={MarcacoesDeProcessos}
          codigo="tab_tags_marcacoes"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/especie-titulo`}
          component={EspecieTitulo}
          codigo="tab_especie_titulo"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/fases-processo`}
          component={FasesColaboradores}
          codigo="tab_fases"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/categoria-instrucao`}
          component={CategoriaInstrucao}
          codigo="tab_categoria_instrucao"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/motivo-inadimplencia`}
          component={MotivoInadimplencia}
          codigo="tab_motivo_inadimplencia"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/comissao-periodo`}
          component={ComissaoPeriodo}
          codigo="tab_comissao_periodo"
        />
        {/*
    <Route
      path={`${match.url}/cad/tabelas/periodo-comissao`}
      component={PeriodoComissao}
    />
    */}
        <PrivateRoute
          path={`${match.url}/cad/tabelas/parametros-atraso`}
          component={ParametrosAtraso}
          codigo="tab_param_cob"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/parametros-carteira`}
          component={ParametrosCarteira}
          codigo="tab_param_car"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/campanhas-desconto`}
          component={CampanhaDesconto}
          codigo="tab_camp_desc"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/modalidade-contrato`}
          component={ModalidadeContrato}
          codigo="tab_modal_contr"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/comissao-escalonada`}
          component={ComissaoEscalonada}
          codigo="tab_comissao_escalonada"
        />
        <PrivateRoute
          path={`${match.url}/cad/tabelas/modelos-prestacao`}
          component={PrestacaoModelosImpressao}
          codigo="tab_modelos_pc"
        />
        <PrivateRoute
          path={`${match.url}/cad/multi-empresa`}
          component={Multiempresas}
          codigo="cad_multi_empresa"
        />
        <PrivateRoute
          path={`${match.url}/cad/inicio`}
          component={Cadastros}
          codigo="cad"
        />
        <PrivateRoute
          exact
          path={`${match.url}/cad`}
          component={Cadastros}
          codigo="cad"
        />
      </Switch>
    </>
  );
}
